<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import { validationMixin } from 'vuelidate'
import { required, email, numeric, between } from 'vuelidate/lib/validators'
import moment from 'moment'
// import moment from 'moment-timezone'
import supportsType from './supports-type'

let thisYear = new Date().getFullYear()
// let timeZoneOffsetGuess = moment().tz(moment.tz.guess()).format('Z')

export default {
  name: 'TipSightingForm',

  mixins: [validationMixin],

  data() {
    return {
      state: 'form',
      form_type: '',
      apiUrl: '',

      timezone_data: {},
      relationship_to_child_data: {},
      province_data_canada: {},
      province_data_usa: {},

      supportsDate: supportsType(document.getElementById('when_seen.date') || document.getElementById('when_learned.date')),
      supportsTime: supportsType(document.getElementById('when_seen.time') || document.getElementById('when_learned.time')),
      dayMax: 31,
      yearSelect: '',
      monthSelect: '',
      daySelect: '',

      child_first_name: '',
      child_last_name: '',

      when_seen: {
        date: '',
        time: '',
        timezone: '',

        year: thisYear,
        month: '',
        day: '',
      },
      where_seen: '',
      circumstance: '',
      appearance: '',
      child_with_someone: '',
      companion_first_name: '',
      companion_last_name: '',
      companion_description: '',

      sighter_first_name: '',
      sighter_last_name: '',
      sighter_age: '',
      sighter_phone: undefined,
      sighter_email: undefined,

      info: '',
      where_learned: '',
      when_learned: {
        date: '',
        time: '',
        timezone: '',

        year: thisYear,
        month: '',
        day: '',
      },
      someone_has_more_info: '',
      info_first_name: '',
      info_last_name: '',
      info_relationship_to_child: '',
      info_address: '',
      info_address2: '',
      info_city: '',
      info_province: '',
      info_postalcode: '',
      info_phone: undefined,
      info_email: undefined,

      tipper_first_name: '',
      tipper_last_name: '',
      tipper_age: '',
      tipper_phone: undefined,
      tipper_email: undefined,

      other_info: '',
      prompting: '',
      hear_about_other: '',
    }
  },

  computed: {
    typeSighting() { return this.form_type === 'sighting' },
    typeTip() { return this.form_type === 'tip' },
    showForm() { return this.state === 'form' },
    showProcessing() { return this.state === 'processing' },
    showSuccess() { return this.state === 'success' },
    showError() { return this.state === 'error' },
  },

  validations() {
    let v = {
      child_first_name: {},
      child_last_name: {},

      info_email: { email },
      sighter_email: { email },

      other_info: {},
      prompting: {},
      hear_about_other: {},
    }

    if (this.typeTip) {
      v = {
        info: { required },
        where_learned: {},
        when_learned: {
          date: { },
          time: { required },
          timezone: { required },

          year: { },
          month: { },
          day: { },
        },

        someone_has_more_info: { required },
        info_first_name: {},
        info_last_name: {},
        info_relationship_to_child: {},
        info_address: {},
        info_address2: {},
        info_city: {},
        info_province: {},
        info_postalcode: {},
        info_phone: {},
        info_email: { email },

        tipper_first_name: {},
        tipper_last_name: {},
        tipper_age: { numeric },
        tipper_phone: {},
        tipper_email: { email },
        ...v
      }

      if (this.supportsDate) {
        v.when_learned.date = { required }
      } else {
        v.when_learned.year = { required }
        v.when_learned.month = { required }
        v.when_learned.day = {
          required,
          numeric,
          between: between(0, parseInt(this.dayMax))
        }
      }
    }

    if (this.typeSighting) {
      v = {
        when_seen: {
          date: { },
          time: { required },
          timezone: { required },

          year: { },
          month: { },
          day: { },
        },
        where_seen: { required },
        circumstance: { required },
        appearance: { required },
        child_with_someone: { required },
        companion_first_name: {},
        companion_last_name: {},
        companion_description: {},

        sighter_first_name: {},
        sighter_last_name: {},
        sighter_age: { numeric },
        sighter_phone: {},
        sighter_email: { email },
        ...v
      }

      if (this.supportsDate) {
        v.when_seen.date = { required }
      } else {
        v.when_seen.year = { required }
        v.when_seen.month = { required }
        v.when_seen.day = {
          required,
          numeric,
          between: between(0, parseInt(this.dayMax))
        }
      }
    }

    return v
  },

  watch: {
    form_type(formType) {
      console.log('form type chosen:', formType)

      this.apiUrl = `/api/${formType}/`

      if (formType === 'tip') {
        axios.get('/api/countries/1/provinces/')
          .then(response => {
            this.province_data_canada = response['data']
          })
          .catch(error => {
            console.log(error)
          })

        axios.get('/api/countries/236/provinces/')
          .then(response => {
            this.province_data_usa = response['data']
          })
          .catch(error => {
            console.log(error)
          })

        axios.get('/api/relationship/')
          .then(response => {
            this.relationship_to_child_data = response['data']
          })
          .catch(error => {
            console.log(error)
          })
      }

      if (!this.supportsDate) {
        // use fallback fields instead
        this.setupDateFallback(formType)
      }
    },
    state(stateChange) {
      const formEl = document.getElementById('tip-sighting-form')
      this.$nextTick(() => {
        window.scroll(0, formEl.getBoundingClientRect().top + (window.scrollY - 20))
      })
    }
  },

  watch: {
    form_type(formType) {
      console.log('form type chosen:', formType)

      this.apiUrl = `/api/${formType}/`

      axios.get('/api/timezones/?limit=50')
        .then(response => {
          this.timezone_data = response['data']
        })
        .catch(error => {
          console.log(error)
        })

      if (formType === 'tip') {
        axios.get('/api/countries/1/provinces/')
          .then(response => {
            this.province_data_canada = response['data']
          })
          .catch(error => {
            console.log(error)
          })

        axios.get('/api/countries/236/provinces/')
          .then(response => {
            this.province_data_usa = response['data']
          })
          .catch(error => {
            console.log(error)
          })

        axios.get('/api/relationship/')
          .then(response => {
            this.relationship_to_child_data = response['data']
          })
          .catch(error => {
            console.log(error)
          })
      }

      if (!this.supportsDate) {
        // use fallback fields instead
        this.setupDateFallback(formType)
      }
    },
    state(stateChange) {
      const formEl = document.getElementById('tip-sighting-form')
      this.$nextTick(() => {
        window.scroll(0, formEl.getBoundingClientRect().top + (window.scrollY - 20))
      })
    }
  },

  mounted() {
    window._paq.push(['FormAnalytics::scanForForms', document.getElementById('tip-sighting-form')])

    document.addEventListener('change', (e) => {
      if (e.target === this.monthSelect) {
        this.manageDays(this.daySelect, this.yearSelect.value, this.monthSelect.value)
      }
    })
  },

  mounted() {
    window._paq.push(['FormAnalytics::scanForForms', document.getElementById('tip-sighting-form')])

    document.addEventListener('change', (e) => {
      if (e.target === this.monthSelect) {
        this.manageDays(this.daySelect, this.yearSelect.value, this.monthSelect.value)
      }
    })
  },

  methods: {
    submit() {
      if (this.$v.$invalid) {
        // Form has errors
        this.$v.$touch()
        this.$nextTick(() => this.scrollToError())
        return
      }

      let payload = {
        'contacts': [
          {
            'contact_type': 1,
            'first_name': this.child_first_name,
            'last_name': this.child_last_name
          }
        ],
        'other_info': this.other_info,
        'prompting': this.prompting,
        'hear_about_other': this.hear_about_other,
        'organization': 1
      }

      if (this.typeSighting) {
        payload = {
          'when_seen': this.formatDateString(this.when_seen),
          'where_seen': this.where_seen,
          'circumstance': this.circumstance,
          'appearance': this.appearance,
          'child_with_someone': parseInt(this.child_with_someone),
          'companion_description': this.companion_description,
          ...payload
        }
        let sighter_contact_person = {
          'contact_type': 10,
          'first_name': this.sighter_first_name,
          'last_name': this.sighter_last_name,
          'age': parseInt(this.sighter_age),
          'email': this.sighter_email,
          'phone': this.sighter_phone
        }
        let companion_contact_person = {
          'contact_type': 8,
          'first_name': this.companion_first_name,
          'last_name': this.companion_last_name
        }
        payload.contacts.push(sighter_contact_person, companion_contact_person)
      }

      if (this.typeTip) {
        payload = {
          'info': this.info,
          'when_learned': this.formatDateString(this.when_learned),
          'where_learned': this.where_learned,
          'someone_has_more_info': parseInt(this.someone_has_more_info),
          ...payload
        }
        let tipper_contact_person = {
          'contact_type': 11,
          'first_name': this.tipper_first_name,
          'last_name': this.tipper_last_name,
          'age': parseInt(this.tipper_age),
          'email': this.tipper_email,
          'phone': this.tipper_phone
        }
        let someone_more_info_contact_person = {
          'contact_type': 12,
          'first_name': this.info_first_name,
          'last_name': this.info_last_name,
          'relationship_to_child': this.info_relationship_to_child,
          'address': this.info_address,
          'aptunit': this.info_address2,
          'city': this.info_city,
          'province': this.info_province,
          'postalcode': this.info_postalcode,
          'email': this.info_email,
          'phone': this.info_phone
        }
        payload.contacts.push(tipper_contact_person, someone_more_info_contact_person)
      }

      this.state = 'processing'
      const csrftoken = Cookies.get('csrftoken')

      axios.post(this.apiUrl, payload, {'headers': { 'X-CSRFToken': csrftoken }}).then(
        this.success,
        this.error
      )
    },

    error(error) {
      this.state = 'error'
    },

    success(response) {
      this.state = 'success'
      // window.location.assign(response.data.url)
    },

    getFocusableEls() {
      const focusables = this.$el.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]')
      return Array.prototype.slice.call(focusables)
    },
    scrollToError() {
      const errorEls = [...this.$el.querySelectorAll('.error')]
      const firstError = errorEls.filter(el => el.tagName.toUpperCase() !== 'LEGEND')[0]

      if (firstError) {
        const focusTarget = this.getFocusableEls().filter(formEl => firstError.contains(formEl))
        focusTarget[0].focus()
      }
    },

    formatDateString() {
      let dateString = this.typeSighting ? this.$data.when_seen.date : this.$data.when_learned.date
      let timeString = this.typeSighting ? this.$data.when_seen.time : this.$data.when_learned.time
      let tzOffset = this.typeSighting ? this.$data.when_seen.timezone : this.$data.when_learned.timezone

      let timeZoneString = this.formatTimeZone(tzOffset)

      if (!this.supportsDate) {
        let day = this.typeSighting ? this.$data.when_seen.day : this.$data.when_learned.day
        if (day.length === 1) {
          day = `0${day}`
        }
        dateString = this.typeSighting
          ? `${this.$data.when_seen.year}-${this.$data.when_seen.month}-${day}`
          : `${this.$data.when_learned.year}-${this.$data.when_learned.month}-${day}`
      }

      return moment(dateString + 'T' + timeString + timeZoneString).format()
      // return `${dateString}T${timeString}${timeZoneString}`
    },

    formatTimeZone(offsetString) {
      let tzInitialValue = offsetString
      let tzSplit = tzInitialValue.split('.')
      let isNegative = false

      if (tzInitialValue.match(/^-{1}/)) isNegative = true

      // TODO: make all this less brittle and horrible

      if (isNegative && tzSplit[0].length === 2) {
        tzSplit[0] = `-0${tzSplit[0].replace(/^-{1}/, '')}`
      }
      if (!isNegative && tzSplit[0].length === 1) {
        tzSplit[0] = `0${tzSplit[0]}`
      }
      if (tzSplit[1] === '25') {
        tzSplit[1] = '15'
      }
      if (tzSplit[1] === '50') {
        tzSplit[1] = '30'
      }
      if (tzSplit[1] === '75') {
        tzSplit[1] = '45'
      }

      let formattedString = tzSplit.join(':')
      if (!isNegative) formattedString = `+${formattedString}`

      // console.log('timezone change:', formattedString)
      return formattedString
    },

    setupDateFallback(type) {
      this.$nextTick(() => {
        // TODO: accomplish this in a less insane manner
        this.yearSelect = type === 'sighting'
          ? document.getElementById('when_seen.year')
          : document.getElementById('when_learned.year')
        this.monthSelect = type === 'sighting'
          ? document.getElementById('when_seen.month')
          : document.getElementById('when_learned.month')
        this.daySelect = type === 'sighting'
          ? document.getElementById('when_seen.day')
          : document.getElementById('when_learned.day')

        this.populateYears(this.yearSelect)
      })
    },
    populateYears(el) {
      const date = new Date()
      const year = date.getFullYear()
      let first_iter = true

      for (let i = 0; i <= 100; i++) {
        let option = document.createElement('option')
        option.value = year - i
        option.textContent = year - i

        if (first_iter) {
          option.setAttribute('selected', 'selected')
          first_iter = false
        }

        el.appendChild(option)
      }
    },
    manageDays(el, yearValue, monthValue) {
      // replacing <option> els breaks the ability to reselect days in some versions of Firefox,
      // so these can instead be managed with toggling the disabled attr

      let dayNum
      let months31 = ['01', '03', '05', '07', '08', '10', '12']
      let months30 = ['04', '06', '09', '11']

      if (months31.includes(monthValue)) {
        dayNum = 31
      } else if (months30.includes(monthValue)) {
        dayNum = 30
      } else {
        let leap = (yearValue % 4 === 0 && yearValue % 100 !== 0) || yearValue % 400 === 0
        dayNum = leap ? 29 : 28
      }

      this.dayMax = dayNum
    },

  },

}
</script>



// WEBPACK FOOTER //
// js/TipSightingForm.vue